export const iconFontAwesomeMusicVideoGuitar = (
	<i className="fa-solid fa-guitar"></i>
);
